var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEmailSentRegular = function SvgEmailSentRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.563 8.25v.629l4.703 3.855a1.526 1.526 0 0 0 1.941 0l1.395-1.148A5.045 5.045 0 0 0 12 13.8a2.877 2.877 0 0 1-3.582-.055l-3.855-3.172v4.676c0 .246.19.438.437.438h7.3c.192.492.466.93.794 1.312H5c-.984 0-1.75-.766-1.75-1.75v-7c0-.957.766-1.75 1.75-1.75h10.5c.957 0 1.75.793 1.75 1.75v.902c-.164 0-.3-.027-.438-.027-.546 0-1.039.082-1.503.246l.629-.492V8.25a.47.47 0 0 0-.438-.438H5a.45.45 0 0 0-.438.438Zm16.187 5.688a3.938 3.938 0 0 1-3.938 3.937 3.921 3.921 0 0 1-3.937-3.938c0-2.16 1.75-3.937 3.938-3.937 2.16 0 3.937 1.777 3.937 3.938Zm-2.734-1.176-1.641 1.668-.793-.793a.463.463 0 0 0-.629 0 .463.463 0 0 0 0 .629l1.094 1.093a.463.463 0 0 0 .629 0l1.969-1.968a.463.463 0 0 0 0-.63.463.463 0 0 0-.63 0Z"
  })));
};

export default SvgEmailSentRegular;